<template>
  <div class="content" @click="openMiniapp">打开聚爱车小程序</div>
</template>

<script>
export default {
  data() {
    return {
      appid: "wxf981ee300628151b", // 聚爱车小程序
      path: "packageA/pages/jubao/claim-record",// "pages-function/claim-settlement/record", // 小程序理赔列表的路径
      env_version: "release",
    };
  },
  methods: {
    openMiniapp() {
      const url = `weixin://dl/business/?appid=${this.appid}&path=${this.path}&env_version=${this.env_version}`;
      window.location.href = url;
    },
  },
  mounted() {
    this.openMiniapp();
  },
};
</script>

<style lang="less" scoped>
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>